// Polyfills for js features used in the Dashboard but not supported in some browsers (mainly IE)
import '@/polyfills';
// Notifications plugin. Used on Notifications page
import Notifications from '@/components/NotificationPlugin';
// Validation plugin used to validate forms
import { configure } from 'vee-validate';
// A plugin file where you could register global components used across the app
import GlobalComponents from './globalComponents';
// A plugin file where you could register global directives
import GlobalDirectives from './globalDirectives';
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import SideBar from '@/components/SidebarPlugin';
import {
  formatISODate, formatISODateTime, formatEpochDateTime, formatTime, from, formatDate,
} from '@/utils/date';
// element ui language configuration
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
locale.use(lang);

// vue-bootstrap
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// asset imports
import '@/assets/sass/argon.scss';
import '@/assets/css/nucleo/css/nucleo.css';
import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/en.json';

import { formatNumeric, formatPercentage } from '../utils/format';
import languages from '../utils/languages';

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule] // assign message
  });
});

export default {
  install(Vue) {
    Vue.filter('formatISODate', (value, format) => formatISODate(value, format));
    Vue.filter('formatISODateTime', (value, format) => formatISODateTime(value, format));
    Vue.filter('formatEpochDateTime', (value, format) => formatEpochDateTime(value, format));
    Vue.filter('formatTime', (value, format) => formatTime(value, format));
    Vue.filter('formatDate', (value, format) => formatDate(value, format));
    Vue.filter('formatNumeric', formatNumeric);
    Vue.filter('formatPercentage', formatPercentage);
    Vue.filter('formatArrayLengthSafe', value => ((value === undefined) ? '-' : value.length.toLocaleString()));
    Vue.filter('joinWithSpace', value => (value === undefined ? '' : value.join(',')));
    Vue.filter('from', (value, format) => from(value, format));
    Vue.filter('formatLanguages', value => languages[value].split('Any/').reverse()[0] || value);

    Vue.use(GlobalComponents);
    Vue.use(GlobalDirectives);
    Vue.use(SideBar);
    Vue.use(Notifications);
    Vue.use(BootstrapVue);
    Vue.use(IconsPlugin);
    configure({
      classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
      }
    })
  }
};
